import { SuccessRO } from '@routellers/types/dist/shared/success.ro';

import { ApiMethodDeclaration } from '..';

type ResponseData = SuccessRO;

export const logout: ApiMethodDeclaration<undefined, ResponseData> = () => ({
    url: '/admins/logout',
    method: 'GET',
});
